<script setup lang="ts">
  import Checkbox from '@/shared/ui/checkboxes/Checkbox.vue';

  defineProps<{
    text: string;
    checkbox?: boolean;
    checked?: boolean;
    indeterminate?: boolean;
    thClass?: string;
    thCheckboxClass?: string;
  }>();

  defineOptions({ inheritAttrs: false });

  const emit = defineEmits<{
    'toggle-all': [];
  }>();

  const handleToggleAll = () => {
    emit('toggle-all');
  };
</script>

<template>
  <th
    v-if="checkbox"
    :class="thCheckboxClass ? thCheckboxClass : 'w-20 align-middle text-center'"
  >
    <Checkbox
      id="select-all"
      :checked="checked || false"
      :indeterminate="indeterminate || false"
      @toggle="handleToggleAll"
    />
  </th>
  <th
    :class="
      thClass
        ? thClass
        : 'text-left text-xs font-semibold text-gray-07 pl-6 py-4.5 w-min whitespace-nowrap align-middle'
    "
  >
    <span>{{ text }}</span>
  </th>
</template>
